import { useCallback } from 'react';
import { useApiCall, useRootContext } from '@jarvis/react-portal-addons';
import { UserTenantMgtSvcClient } from '@jarvis/web-stratus-client';

const ACTIVE_STATE = 'Active';
const ADMIN_ROLE = 'Admin';

export const useAdminUsersApiCall = () => {
  const { shell: { authProvider, tenantHandler }, stack } = useRootContext();

  const fetch = useCallback(async () => {
    const userTenantMgtSvcClient = new UserTenantMgtSvcClient(stack, authProvider);

    const tenantResourceId = tenantHandler.getTenantId();

    // /v3/usermgtsvc/userwithtenantdetails?tenantResourceId={tenantResourceId}
    const internalUserListResponse = await userTenantMgtSvcClient.getUserWithTenantList(
      tenantResourceId,
    );

    return internalUserListResponse?.data?.resourceList
      // this filter is to remove the internal hp service admin user
      // this is a copy from what is done on the react-user-management MFE (useUsersApiCall.ts)
      .filter(resource => resource.userTenantDetail?.tenantResourceId !== resource.user?.idpId)
      ?.map(
        resource => ({
          givenName: resource.user?.givenName,
          familyName: resource.user?.familyName,
          email: resource.user?.email?.value,
          role: resource.userTenantDetail?.roleCategory,
          state: resource.userTenantDetail?.state,
          phoneNumber: resource.user?.phoneNumber?.value,
        }),
      )?.filter(user => user.role === ADMIN_ROLE && user.state === ACTIVE_STATE);
  }, [authProvider, stack, tenantHandler]);

  return useApiCall({
    apiCall: fetch,
    init: true,
  });
};

export default useAdminUsersApiCall;
